/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Button, CircularProgress, Typography } from '@material-ui/core'
import FlexForm from '../../FlexForm/FlexForm'

const blue_theme = createMuiTheme({
palette: {
    primary: {
    main: "#2296f3",
    },
    secondary: {
    main: "#dc014e",
    },
},
})

const styles = (theme) => ({

});
class Ticket extends Component {
    state = {}

    componentDidUpdate(prevProps, prevState) {
        console.log("Ticket Config :: Previous : ", prevProps.config)
        console.log("Ticket Config :: Current : ", this.props.config)
    }

    renderUpdateRecord = () => {
        let param_index = this.props.config.params.findIndex(param => param.key === "enable_update_record")
        let param_value = true

        if (param_index === -1) {
            param_value = true
        } else {
            param_value = this.props.config.params[param_index].value.boolean
        }

        if (param_value) {
            return (
                <Button 
                    style = {{marginRight : '10px'}} 
                    fullWidth 
                    variant = 'contained' 
                    color = 'primary' 
                    onClick = {() => this.props.submit()}
                    startIcon = {this.props.updating_record ? <CircularProgress style = {{color : '#FFFFFF'}} size = {20}/> : null}
                >Update Record</Button>
            )
        }
    }

    isHttps = () => {
        if (window.location.protocol === "https:") {
            return true
        } else {
            return false
        }
    }

    autoCopyFieldsExist = () => {
        let auto_copy_fields = [] 
        this.props.config.write.forEach(field => {
            let auto_copy_param = field.component_params.findIndex(param => param.name === 'copy_content')
            if (auto_copy_param !== -1) {
                if (field.component_params[auto_copy_param].value.boolean === true) {
                    auto_copy_fields.push(field)
                }
            }
        })

        if (auto_copy_fields.length > 0) {
            return true
        } else {
            return false
        }
    }


    renderCopyToClipboard = () => {
        console.log("Window Location Protocol : ", window.location.protocol)
        if (this.isHttps() && this.autoCopyFieldsExist()) {
            return (
                <Button 
                    style = {{marginRight : '10px'}} 
                    fullWidth 
                    variant = 'contained' 
                    color = 'primary' 
                    onClick = {() => this.props.copyToClipboard()}
                >Copy To Clipboard</Button>
            )
        }
    }

    render() {
        const { classes } = this.props
        console.log("Write Config : ", this.props.config.write)
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', height : '100%'}}>
                    <FlexForm 
                        key = 'ticket'
                        config = { this.props.config.write } 
                        fields_in_scope = {[]} 
                        update_parent = {(form) => this.props.updateForm(form)} 
                        submit = {(form) =>  this.setForm(form)} 
                        grid_element_width = "33%"
                        drl_url = {this.props.drl_url}
                        ic_name = {this.props.ic_name}
                        on_open = {false}
                        show_attachment = {true}
                    />
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', padding : '10px'}}>
                        {this.renderCopyToClipboard()}
                        {this.renderUpdateRecord()}
                    </div>
                    <div style = {{width : '100%', padding : '10px'}}>
                        {this.props.update_record_error && <Typography variant = 'caption' color = 'secondary'>Error Updating Record in Source</Typography>}
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(Ticket);